import { Bank } from "@assets";
import { Row } from "@components/Flex";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { BodySmall } from "@components/Typography";
import { i18n, Translations } from "@i18n";
import { useStyles } from "./styles";
import { AccountNumberSectionProps } from "./types";

export const AccountNumberSection = ({ accountNumber }: AccountNumberSectionProps) => {
  const styles = useStyles();

  if (!accountNumber) return null;

  const handleCopy = () => {
    navigator.clipboard.writeText(accountNumber);
  };

  return (
    <>
      <Row>
        <div style={styles.container}>
          <Row style={styles.accountContainer}>
            <Bank />
            <BodySmall style={styles.text}>{accountNumber}</BodySmall>
          </Row>
        </div>
        <div style={styles.copyContainer} onClick={handleCopy}>
          <BodySmall>{i18n.t(Translations.AccountNumberSectionCopyLabel)}</BodySmall>
        </div>
      </Row>

      <Spacing size={SpacingSizes.M} />
    </>
  );
};
